<template>
  <div>
    <IndexNavbar />
    <main>
      <section class="pt-20 pb-48" id="battery-2nd-life-solution">
        <div class="container mx-auto px-4" style="margin-top: 50px;">
          <div class="flex flex-wrap justify-center text-center mb-24">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold">Battery 2nd life solutions</h2>
              
            </div>
            <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               We, at AmeiseTech are integral part of circular economy, building solutions on principles of sustainability, providing benefits of effective energy management solution with the use of Second life batteries. This is a unique concept as we are reusing the asset which has got residual value, which is rich in energy content, but lived its life as a battery for a EV and now ready to be used for stationary application, to provide energy source for EV charging Infra, manage peak load at Grid or for various Industry and commercial applications where Back up power is needed. We as AmeiseTech acts as a System Integrator, building the right solution, in terms of Technical parameters and commercial effectiveness. We provide state of art solution which consists of Battery Modules, Invertors, convertors', Battery Management system, Demand Management solution etc. Based on our previous experience of working with Cities and Urban local bodies , Grid operators etc, we see demand for a sustainable & resilient solution. As part of our solution deployment, We would conduct Feasibility analysis, provide Training, Hand holding and Program Management and Operations & Maintenance support.
              </p>
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               In addition to system Integration services we offer consulting services for Smart Cities, Digital Twin, Smart Transportation.

              </p>
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               Our past experience in Smart cities domain, working with Govt as a System integrator which involves activities right from Vision statement, Feasibility study, Stakeholder alignment, DPR preparation and finally program Management. Experience of working with various agencies like, Consulting firm, Master planner, Fuding agencies, Global OEMs, etc.
              
              </p>
              <div class="flex flex-wrap">
                <div class="col-md-3 text-center image-card">
              <div class="flex flex-wrap" >
           <img alt="..." class="max-w-full rounded-lg shadow-lg top-10"
                                src="@/assets/img/battery.png" style="width: 200px; height: 200px;"/>
                <div class="image-title">EV Charging</div>

              </div>
                </div>
                <div class="col-md-3 text-center image-card">
              <div class="flex flex-wrap" >
           <img alt="..." class="max-w-full rounded-lg shadow-lg top-10"
                                src="@/assets/img/factory.png" style="width: 200px; height: 200px;"/>
                              <div class="image-title">Commercial & Industrial
</div>

              </div>
                </div>
                <div class="col-md-3 text-center image-card">
              <div class="flex flex-wrap" >
           <img alt="..." class="max-w-full rounded-lg shadow-lg top-10"
                                src="@/assets/img/port.png" style="width: 200px; height: 200px;"/>
                              <div class="image-title">Port </div>

              </div>
                </div><div class="col-md-3 text-center image-card">
              <div class="flex flex-wrap" >
           <img alt="..." class="max-w-full rounded-lg shadow-lg top-10"
                                src="@/assets/img/cityscape.png" style="width: 200px; height: 200px;"/>
                              <div class="image-title">Cities</div>

              </div>
                </div>
               
              </div>
          </div>
          
        </div>
      </section>

        <section class="pt-20 pb-48" id="smart-cities">
        <div class="container mx-auto px-4">
          
          <div class="flex flex-wrap justify-center text-center mb-24">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold">IoT Solutions for Smart Cities</h2>
              
            </div>
            <p class="text-lg leading-relaxed m-4 text-blueGray-500">
              Ameisetech serves as a turnkey partner for Smart and Safe City initiatives for IT infrastructure. We bring deep-domain expertise in the design, integration, and O&M (Operations & Maintenance) of components like Advance Surveillance, Command Control Centre, E-governance, GIS, Intelligent Traffic Management, Vehicle tracking system, Smart Lighting, Solid waste management, Environmental sensor, Utility integration etc. We can also help Authority to plan monetization through Video display board, e-challan, Smart Parking, Public Wi-Fi, Fiber to home, Unified payment portal and digital wallets. The cities then use this data to improve infrastructure, energy consumption, public utilities and more. The model of smart city management is to develop a city with sustainable growth, focusing on the balance of environment and energy saving and revenue generation.




              </p>
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               Ameisetech helps improve government efficiency, grow business revenue and improve service delivery by fusing analytics with IoT data.

              Tap into – and get more out of – the connected world. Take full advantage of data streaming in from connected citizens, sensors, systems, and products. Ameisetech delivers IoT solutions for smart cities that enable you to:

              

              </p>
              <div class="flex flex-wrap" style="width: 70%;">
           <img alt="..." class="max-w-full rounded-lg shadow-lg"
                                src="@/assets/img/smart-infrastructure.png" />
            </div>
<ul class="list-none mt-6">
                                
                                <li class="py-2">
                                    <div class="flex items  -center">
                                        <i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Boost energy efficiency. </span>Optimize delivery of energy and electricity by applying analytics to data that’s streaming from smart grid sensors.
                                        </span>

                                    </div>
                                </li> 
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Improve citizen services. </span> Automatically detect when citizen services – such as trash or recycling – are needed, and provide those services more effectively.</span></div>      
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Take control of transportation issues. </span>  Dynamically manage traffic flow and parking availability, which helps boost the economy while reducing citizen transit and times.
                                            </span></div> 
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Proactively maintain public assets and infrastructure. </span>  Automatically know when vehicles, bridges and other assets or infrastructure are likely to need maintenance.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Anticipate disruptions. </span>  Dynamically sense the citizen environment and mitigate government service disruptions using social media and other citizen data.</span></div>
                                </li>

                            </ul>
              
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               Our past experience in Smart cities domain, working with Govt as a System integrator which involves activities right from Vision statement, Feasibility study, Stakeholder alignment, DPR preparation and finally program Management. Experience of working with various agencies like, Consulting firm, Master planner, Fuding agencies, Global OEMs, etc.
              </p>
                
          </div>
          
        </div>
      </section>


    <section class="pt-20 pb-48" id="digital-twin">
        <div class="container mx-auto px-4">
          
          <div class="flex flex-wrap justify-center text-center mb-24">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold">Digital Twin</h2>
              
            </div>
            <p class="text-lg leading-relaxed m-4 text-blueGray-500">
              Digital twin, are a virtual representation of real-world entities and processes, synchronized at a specified frequency and fidelity. In practice, this can have a wide variety of interpretations. What does virtual mean? What counts as simulation? What counts as a digital twin or doesn’t?
              </p>
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
               The history of digital twins goes back as far as the 1970s with simulators used by NASA, progresses with the advent of CAD technology in the 1980s, and then the application of both in the aerospace and manufacturing industries in the 1990s and 2000s. Engineers would use a combination of simulation, 3D visualization, and real-time data to aid in the construction of highly complex machinery such as airplane engines. This technology was used for decades before the term “digital twin” appeared, which wasn’t until 2010.

Since then, digital twin technology has come to be understood to include all the previous technology plus a mix of the Internet of Things (IoT), artificial intelligence (AI), and cloud computing. Nowadays, digital twins are proving useful in a variety of fields — not just for building airplanes, but entire buildings and cities.

Digital twin technology is what has opened the door to address the problem that buildings account for 40% of global carbon emissions. But what type of digital twin is being used exactly? Is it the same type of digital twin that was used decades ago, or is it different now?

The best way to understand digital twins is on a scale of five dimensions ranging from simple to complex.

              </p>
              <h2 class="text-4xl font-semibold">Digital twin in five dimensions</h2>
              <p>A useful way to understand digital twins is between two planes and five different dimensions of functionality. A digital twin in its simplest form is the digitalization and visualization of a physical asset in three dimensions: a static twin, a dynamic twin, and an operational twin. In its advanced form, it is a powerful engine of optimization in two more dimensions: simulation and prediction. As a twin becomes more advanced, users can benefit from improved support with decision-making and planning.

</p>
              <div class="flex flex-wrap" style="width: 70%;">
           <img alt="..." class=""
                                src="@/assets/img/5-dimension-digital-twin.webp" />
              </div>
              
              <!-- <h2 class="text-4xl font-semibold" style="margin-top: 10px;">How Does A Digital Twin Work?</h2> -->
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">Digital twin work by using real-time data from sensors installed on physical assets. This data is transmitted to the digital twin, which uses it to create a virtual representation of the asset. The digital twin can then be used to monitor the asset's performance, identify potential issues, and optimize its operation.</p>
           <div class="flex flex-wrap" style="width: 70%;">
           <img alt="..." class=""
                                src="@/assets/img/How-To-Create-A-Digital-Twin.png" />
              
              </div>
<div class="text-lg leading-relaxed m-4 text-blueGray-500">
            <ul class="list-disc m-4 text-left">
              <li>
               <p><span class="font-semibold">1. Data Collection:</span>The first step in operating a digital twin is data collection. Sensors attached to the physical entity gather real-time data about various parameters.
            <br>  This could include temperature, pressure, speed, and more. The type of data collected depends on the nature of the physical entity and the purpose of the digital twin.
</p> 
              </li>
            <li>
               <p><span class="font-semibold">2. Data Transmission:</span>Once the data is collected, it must be transmitted to a digital platform. This is where connectivity technologies such as the Internet of Things (IoT) come into play.
            <br>  The IoT enables seamless and real-time data transfer from the physical entity to the digital platform.
</p> 
              </li>
              <li>
               <p><span class="font-semibold">3. Data Processing and Analysis:</span>Upon reaching the digital platform, the data undergoes processing and analysis. Advanced analytics techniques are used to process the data and extract meaningful insights.
                <br>
                These insights can provide valuable information about the current state and performance of the physical entity.
</p>
              </li>
              <li>
               <p><span class="font-semibold">4. Creation of the Digital Twin:</span>The processed data is then used to create a real-time digital representation of the physical entity. This digital representation mirrors the physical entity’s state, behavior, and performance in the real world.
                <br>
                It provides a virtual platform where the physical entity can be monitored, analyzed, and even manipulated without interacting with the actual entity.
               </p></li>
              <li>
               <p><span class="font-semibold">5. Real-Time Monitoring:</span>One of the critical features of a digital twin is its ability to provide real-time monitoring. The digital twin updates continuously as new data is collected from the physical entity.
                <br>
                It allows for real-time tracking of the state and performance of the physical entity. Any changes in the physical entity are immediately reflected in the digital twin.
               </p></li>
              <li>
               <p><span class="font-semibold">6. Predictive Analysis:</span>Beyond real-time monitoring, digital twins also enable predictive analysis. By analyzing historical and real-time data, predictive models can be built to forecast future performance and detect potential issues.
                <br>  This predictive capability can be invaluable in preventing failures, optimizing performance, and planning maintenance activities.
               </p></li>
              <li>
               <p><span class="font-semibold">7. Continuous Improvement:</span>The operation of a digital twin is continuous. The digital twin becomes more accurate and valuable as more data is collected and analyzed.
                <br>  This continuous improvement allows the digital twin to adapt to changes in the physical entity and the environment, making it a dynamic and evolving tool.
               </p></li>  

                 </ul>
                 </div>
 </div>
          
        </div>
      </section>

   


    </main>
    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team1 from "@/assets/img/PPR0001023_1colored.png";
import team2 from "@/assets/img/jnpt.logo.jpg";
import team3 from "@/assets/img/jnpt1.png";
import team4 from "@/assets/img/jnpa-logo.png";

export default {
  data() {
    return {
      team1,
      team2,
      team3,
      team4,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },
};
</script>
<style scoped>
  .image-card {
  position: relative;
  width: 300px;
  overflow: hidden;
}

.image-card img {
  width: 100%;
  display: block;
}

.image-title {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55); /* greyed overlay */
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-card:hover .image-title {
  opacity: 1;
  margin-right: 20px;
}

  </style>
